import React, { useEffect, useState } from 'react';

const SmartImage = ({ srcPrimary, srcBackup, alt = '' }) => {
    const [src, setSrc] = useState(null);

    useEffect(() => {
        let cancelled = false;

        (async () => {
            // 优先检测 srcPrimary
            const src1 = await checkImageExists(srcPrimary);
            if (!cancelled) {
                setSrc(src1 ? srcPrimary : srcBackup);
            }
        })();

        return () => (cancelled = true);
    }, [srcPrimary, srcBackup]);

    if (!src) return null; // 没有可用图片时不渲染

    return <img id={src} src={src} alt={alt} loading="lazy" />;
}

// 检查图片是否存在
function checkImageExists(url) {
    return new Promise((resolve) => {
        if (!url) return resolve(false);
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
    });
};

export default SmartImage;